import { v4 as uuidv4 } from "uuid";

//
import IMG1 from "../images/service-1.jpg";
import IMG2 from "../images/service-2.jpg";
import IMG3 from "../images/service-3.jpg";
import IMG4 from "../images/service-4.jpg";
import IMG5 from "../images/service-5.jpg";
import IMG6 from "../images/service-6.jpg";

const list = [
  {
    id: uuidv4(),
    icon: "icon-service-eye-diagnostics",
    title: "serviceSectionEyeExamTitle",
    number: "01",
    to: "/service/1",
    img: IMG1,
    text: "serviceSectionEyeExamText",
  },
  {
    id: uuidv4(),
    icon: "icon-service-cataract",
    title: "serviceSectionDryEyeTitle",
    number: "02",
    to: "/service/2",
    img: IMG2,
    text: "serviceSectionDryEyeText",
  },
  {
    id: uuidv4(),
    icon: "icon-service-glaucoma",
    title: "serviceSectionContactLensExamTitle",
    number: "03",
    to: "/service/3",
    img: IMG3,
    text: "serviceSectionDryEyeText",
  },
  {
    id: uuidv4(),
    icon: "icon-service-laser-correction",
    title: "serviceSectionUrgentVisionCareTitle",
    number: "04",
    to: "/service/4",
    img: IMG4,
    text: "serviceSectionDryEyeText",
  },
  {
    id: uuidv4(),
    icon: "icon-service-vitreoretinal",
    title: "serviceSectionCompleteOpticalTitle",
    number: "05",
    to: "/service/5",
    img: IMG5,
    text: "serviceSectionDryEyeText",
  },
  {
    id: uuidv4(),
    icon: "icon-service-eye-care",
    title: "serviceSectionAdvOcularCareTitle",
    number: "06",
    to: "/service/6",
    img: IMG6,
    text: "serviceSectionDryEyeText",
  },
];

export default list;
